/**
 * @returns {React.ReactElement} The rendered component
 */
const DownloadIcon = () => (
  <svg
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="31px"
    height="31px"
  >
    <path
      fill="currentColor"
      d="M323.3 398.9H76.7c-28.2 0-51.2-23-51.2-51.2v-90.5c0-8.8 7.2-16 16-16s16 7.2 16 16v90.5c0 10.6 8.6 19.2 19.2 19.2h246.6c10.6 0 19.2-8.6 19.2-19.2v-90.5c0-8.8 7.2-16 16-16s16 7.2 16 16v90.5c0 28.3-22.9 51.2-51.2 51.2zM200 235.6c-4.1 0-8.2-1.6-11.3-4.7l-88.1-88.1c-6.2-6.2-6.2-16.4 0-22.6 6.2-6.2 16.4-6.2 22.6 0L184 181V17c0-8.8 7.2-16 16-16s16 7.2 16 16v164l60.8-60.8c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6l-88.1 88.1c-3.1 3.2-7.2 4.7-11.3 4.7z"
    />
  </svg>
);

export default DownloadIcon;
